import { NudgeTypes } from '../constants';
import { getElementHeadingValue, getElementId, getTranslationOrInnerText, isHTMLElement } from 'whisper-base';
export const Definition = {
  selector: '[data-coaching-tips-popover]',
  shouldTrackRenderedForChild: () => {
    return true;
  },
  shouldTrackDismissedForChild: () => {
    return true;
  },
  getNudgeProperties: ({
    element
  }) => {
    var _getElementHeadingVal, _element$querySelecto;
    const nudgeId = getElementId(element);
    const title = (_getElementHeadingVal = getElementHeadingValue(element)) !== null && _getElementHeadingVal !== void 0 ? _getElementHeadingVal : 'no-title';
    const bodyElement = (_element$querySelecto = element.querySelector('[data-test-id="coaching-tip-popover-single-step"]')) !== null && _element$querySelecto !== void 0 ? _element$querySelecto : element.querySelector('[data-test-id="coaching-tip-popover-carousel"]');
    const text = isHTMLElement(bodyElement) ? getTranslationOrInnerText(bodyElement) : 'no-body';
    return Object.assign({
      type: NudgeTypes.COACHING_TIP_TOOLTIP
    }, nudgeId ? {
      id: nudgeId
    } : {}, {
      title,
      text
    });
  }
};